import { render } from "./ShippingForm.vue?vue&type=template&id=a8f0af0a"
import script from "./ShippingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/ShippingForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8f0af0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8f0af0a', __exports__)) {
    api.reload('a8f0af0a', __exports__)
  }
  
  module.hot.accept("./ShippingForm.vue?vue&type=template&id=a8f0af0a", () => {
    api.rerender('a8f0af0a', render)
  })

}


export default __exports__